<template>
    <div class="row" v-if="customer">
        <div class="col-12" v-if="customer.stats">
            <div class="row">
                <div class="col-lg-3 col-sm-6 col-12">
                    <!-- Card -->
                    <div class="card">
                        <div class="card-body">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-2">{{$t('Completed')}}</h6>

                                    <span class="h2 mb-0">{{customer.stats.completed || 0}}</span>

                                    <!-- <span class="badge badge-soft-success mt-n1">+3.5%</span> -->
                                </div>
                                <div class="col-auto">
                                    <!-- Icon -->
                                    <span class="h2 fe fe-calendar text-muted mb-0"></span>
                                </div>
                            </div>
                            <!-- / .row -->
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-2">{{$t('No shows')}}</h6>
                                    <span class="h2 mb-0">{{ customer.stats.noshow || 0 }}</span>
                                </div>
                                <div class="col-auto">
                                    <span class="h2 fe fe-eye-off text-muted mb-0"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                    <!-- Card -->
                    <div class="card">
                        <div class="card-body">
                            <div class="row align-items-center">
                                <div class="col">
                                    <!-- Title -->
                                    <h6 class="card-title text-uppercase text-muted mb-2">{{$t('Cancelled')}}</h6>

                                    <div class="row align-items-center no-gutters">
                                        <div class="col-auto">
                                            <span class="h2 mr-2 mb-0">{{ customer.stats.cancelled || 0}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <span class="h2 fe fe-x-circle text-muted mb-0"></span>
                                </div>
                            </div>
                            <!-- / .row -->
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                    <!-- Card -->
                    <div class="card">
                        <div class="card-body">
                            <div class="row align-items-center">
                                <div class="col">
                                    <!-- Title -->
                                    <h6 class="card-title text-uppercase text-muted mb-2">{{$t('Late')}}</h6>

                                    <!-- Heading -->
                                    <span class="h2 mb-0">{{ customer.stats.late || 0}}</span>
                                </div>
                                <div class="col-auto">
                                    <!-- Icon -->
                                    <span class="h2 fe fe-watch text-muted mb-0"></span>
                                </div>
                            </div>
                            <!-- / .row -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row">
                <div class="col-lg-6 col-sm-6 col-12">
                    <div class="card pb-3 h-5 similar">
                        <div class="card-header">{{$t('Details')}}</div>
                        <div class="card-body" v-if="customer.userId.length>0">
                            <div class="m-0 pb-2" v-if="customer.userId.length>0">
                                <h6 class="card-title text-uppercase text-muted mb-2 p-0 m-0">{{$t('Staff')}}</h6>
                                <div class="mb-3 row">
                                    <div class="col-auto ml-2 mb-2" v-for="userId in customer.userId" :key="userId">
                                        <user :user="userId" :avatar="true" />
                                    </div>
                                </div>
                            </div>
                            <div class="m-0 pb-2" v-if="source">
                                <h6 class="card-title text-uppercase text-muted mb-2">{{$t('Source')}}</h6>
                                <span class="h4">{{ source.label || 'N/A'}}</span>
                            </div>

                            <div class="m-0 pb-2" v-if="customer.source.referer">
                                <h6 class="card-title text-uppercase text-muted mb-2">{{$t('Referer')}}</h6>
                                <span class="h4">{{ customer.source.referer || 'N/A'}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-sm-6 col-12">
                    <div class="card pb-3 similar">
                        <div class="card-header">{{$t('Customer passport')}}</div>
                        <div class="card-body">
                            <div class="p-1 mb-3">
                                <h6 class="card-title text-uppercase text-muted mb-0">{{$t('Date created')}}</h6>
                                <span class="h4">{{ customer.createdAt | moment('MMMM DD, YYYY ')}}</span>
                            </div>

                            <div class="row mb-3">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">{{$t('Birthdate')}}</h6>
                                    <span class="h4">{{ customer.birth_date | moment('MMMM DD, YYYY ')}}</span>
                                </div>
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">{{$t('Age')}}</h6>
                                    <span class="h4">{{ customer.birth_date | moment('diff','years') * (-1)}}</span>
                                </div>
                            </div>
                            <div class="p-1 mb-3">
                                <h6 class="card-title text-uppercase text-muted mb-0">{{$t('Gender')}}</h6>
                                <span class="h4">{{ $t(customer.gender)}}</span>
                            </div>
                            <div class="p-1 mb-3">
                                <h6 class="card-title text-uppercase text-muted mb-0">{{$t('Address')}}</h6>
                                <span class="h4">{{ customer.address || 'N/A'}}</span>
                            </div>
                            <div class="p-1 mb-3">
                                <h6 class="card-title text-uppercase text-muted mb-0">{{$t('Phone')}}</h6>
                                <span class="h4">{{ customer.phone}}</span>
                            </div>
                            <div class="p-1 mb-3">
                                <h6 class="card-title text-uppercase text-muted mb-0">Email</h6>
                                <span class="h4">{{ customer.email}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-6 col-sm-6 col-12" v-for="(section, sectionIndex) in fields" :key="sectionIndex">
            <div class="card pb-3 similar">
                <div class="card-header">{{ section.label }}</div>
                <div class="card-body">
                    <div v-for="(field, index) in section.fields" :key="index" class="p-1 mb-3">
                        <h6 class="card-title text-uppercase text-muted mb-0">{{ field.label }}</h6>
                        <span
                            class="h4"
                            v-if="customer.details && customer.details[field.name]"
                        >{{ customer.details[field.name]}}</span>
                        <span class="text-muted" v-else>N/A</span>
                    </div>
                </div>
            </div>
        </div>

        <lab-modal id="LabModal"></lab-modal>
        <print-lab-modal id="PrintLabModal"></print-lab-modal>
        <remove-modal id="LabRemoveModal"></remove-modal>
    </div>
</template>


<script>

import { modalMixins } from '@/mixins/modal.js'
import { mapActions, mapGetters } from 'vuex';
import ConfirmableButton from '@/components/ConfirmableButton';
import StatusBadge from "@/Pages/Company/Tasks/StatusBadge"
import LabModal from "@/Pages/Company/Labs/LabModal";
import PrintLabModal from "@/Pages/Company/Labs/PrintLabModal";
import RemoveModal from "@/Pages/Company/Labs/RemoveModal";
import User from '@/components/User.vue'
import LabsList from '@/components/Lab/LabsList.vue'
import TasksList from '@/components/Tasks/TasksListComponent.vue'
export default {
    mixins: [modalMixins],
    props: ['customerId'],
    components: {
        User,
        ConfirmableButton,
        StatusBadge,
        LabModal,
        LabsList,
        TasksList,
        PrintLabModal,
        RemoveModal
    },

    data() {
        return {
            data: {},
            // fields: [],
        }
    },
    computed: {
        ...mapGetters('labs', { findLabsInStore: 'find' }),
        ...mapGetters('customers', {
            getCustomerFromStore: 'get'
        }),
        ...mapGetters('sources', {
            getSourceFromStore: 'get'
        }),
        ...mapGetters('my-company', {
            getMyCompany: 'get'
        }),
        ...mapGetters('tasks', {
            getTasks: 'find'
        }),
        company() {
            return this.getMyCompany('mine');
        },
        fields() {
            return this.company.fields;
        },
        customer() {

            if (!this.customerId) return;
            return this.getCustomerFromStore(this.customerId);

        },
        source() {
            if (!this.customer.source) return null;
            return this.getSourceFromStore(this.customer.source.Id);
        },
    },
    created() {
        // this.getMyCompany("mine").then(data => {
        //     this.fields = data.fields || [];
        // });
    },
}
</script>

<style>
.similar .card-body {
    height: 200px;
    overflow-y: auto;
}
</style>
